import * as Yup from 'yup';
import { messages } from 'app/config/constants';

export const caseRevisionValidationSchema = Yup.object({
  idCaseRevision: Yup.number().notRequired(),
  revisionType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  revisionName: Yup.string().required(messages.MANDATORY_FIELD),
  revisionMark: Yup.string().required(messages.MANDATORY_FIELD),
  revisionDate: Yup.date().required(messages.MANDATORY_FIELD),
  authorizedAuditor: Yup.object({
    authorizationNumber: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  }),
  multipartFile: Yup.object().when(['idCaseRevision'], keys => {
    if (keys && !keys[0]) {
      return Yup.mixed().required(messages.MANDATORY_FIELD);
    } else {
      return Yup.mixed().notRequired();
    }
  }),
})

export const caseRevisionDataValidationSchema = Yup.object({
  reportsAttached: Yup.boolean(),
  explanation: Yup.array().when('reportsAttached', (keys, schema) =>
    keys[0] ? schema.min(1, messages.MANDATORY_FIELD) : schema.notRequired()
  )
})


